import * as RadixSwitch from '@radix-ui/react-switch';
import classNames from 'classnames';
import { useId } from 'react';
import styles from './Switch.module.scss';

type TSwitchSize = 'xs' | 's' | 'm';

interface ISwitchProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  size?: TSwitchSize;
  label?: string;
  id?: string;
  name?: string;
  required?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function Switch({
  checked,
  onCheckedChange,
  disabled,
  size = 'xs',
  label,
  id,
  name,
  required,
  className,
  'aria-label': ariaLabel,
}: ISwitchProps) {
  'use memo';

  const generatedId = useId();
  const resolvedId = id ?? generatedId;

  return (
    <div className={classNames(styles.wrapper, { [styles.disabled]: disabled }, className)}>
      {label && (
        <label htmlFor={resolvedId} className={styles.label}>
          {label}
        </label>
      )}
      <RadixSwitch.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        id={resolvedId}
        name={name}
        required={required}
        aria-label={ariaLabel}
        className={classNames(styles.track, styles[size])}
      >
        <RadixSwitch.Thumb className={classNames(styles.thumb, styles[size])} />
      </RadixSwitch.Root>
    </div>
  );
}
